import React from 'react';
import { Select } from '@shopify/polaris';
import { handleFilterChange } from '../FilterEngine';

const productFilterDefinition = (t, props, setTableFilters, options, selected) => ({
  key: 'product',
  label: t('products.plural'),
  filter: (
    <Select
      label={t('products.plural')}
      labelHidden
      options={options}
      value={selected}
      onChange={handleFilterChange(props, setTableFilters, 'product')}
    />
  ),
  shortcut: true
});

export default productFilterDefinition;
